import apiClient from "@/app/api/client";

export const devicesService = {
	async deactivate(id: string): Promise<void> {
		await apiClient.delete(`/devices/${id}`);
	},
	async activate(id: string): Promise<void> {
		await apiClient.post(`/devices/${id}/activate`);
	},
};
